import React, { Component } from 'react';
import AuthNavbar from '../navigation/authnavigation.jsx'
import GuestNavbar from '../navigation/guestnavbar.jsx'
import DefaulNavbar from '../navigation/defaultnavbar.jsx';
import PrivacyPolicy from '../privacypolicy/privacypolicy.jsx'
import LeftLink from '../leftlink/leftlink.jsx'

class Privacy extends Component {
    render() {
        
        return (
            <div>
                {localStorage.getItem("loginState") === "true" ?
                    <div className="row" >
                        <div className="col-sm-12 p-0 m-0">
                            <AuthNavbar />
                        </div>
                        <div className="container" style={{ }}>
                            <div className="row">
                                {/* <div className="col-sm-3 box-shadow-style nopadding" style={{ minHeight: "470px" }}>
                                    <LeftLink />
                                </div> */}
                                <div className="col-sm-12" style={{ padding: "0px 30px" }}>

                                    <div className="row articles-pages" style={{ padding: "12px 0px", minHeight: "476px" }}>
                                        <PrivacyPolicy />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div>
                        <div className="col-sm-12 p-0 m-0">
                            <DefaulNavbar />
                        </div>
                        <div className="container" style={{ marginTop: "80px" }}>
                            <div className="row articles-pages">
                                <PrivacyPolicy />
                            </div>
                        </div>
                    </div>}
            </div>
        );
    }
}

export default Privacy;


// WEBPACK FOOTER //
// ./src/components/authpages/privacy.jsx